import $ from "jquery";
// old imports
let CollectionCarousel = require("../../components/nounproject-collection-carousel")
        .default,
    DownloadStore = require("../stores/downloadstore").default,
    get_parameter_by_name = require("../helpers/get_parameter_by_name").default,
    Metrics = require("../helpers/metrics").default,
    React = require("react"),
    updateQuerystring = require("../helpers/update_querystring").default;

import Waypoint from "react-waypoint";
import classnames from "classnames";

// new imports
import { connect } from "react-redux";
import isEmpty from "lodash/isEmpty";

import * as actions from "../../actions/actions";
import * as actionTypes from "../../actions/actionTypes";
import SearchInfoBarContainer from "../../containers/infobar";

import { IconlistLoading } from "../../components/nounproject-iconlist-classic-loading";
import { NoIconResults } from "../../components/nounproject-iconlist-classic-no-results";
import { IconRow } from "../../components/nounproject-iconlist-classic-row";
import { phases, licenses } from "../../reducers/download";

import Modal from "../../containers/modal";
class Icon_List extends React.Component {
    componentWillReceiveProps(nextProps) {
        switch (nextProps.apiResponse.actionType) {
            case actionTypes.SEARCH_ICONS:
            case actionTypes.FETCH_BEST_COLLECTIONS:
                this.setState({
                    noResults: false,
                    // isInfiniteLoading: false,
                    isFinishedLoading: false
                });
                break;
            case actionTypes.SEARCH_ICONS_SUCCESS:
            case actionTypes.FETCH_BEST_COLLECTIONS_SUCCESS:
                if (nextProps.icons.length === 0) {
                    this.setState({
                        noResults: true,
                        isInfiniteLoading: false,
                        isFinishedLoading: true,
                        didYouMean: nextProps.did_you_mean
                    });
                } else {
                    if (
                        this.props.page > 1 &&
                        this.props.icons.length === nextProps.icons.length
                    ) {
                        this.setState({
                            noResults: false,
                            isInfiniteLoading: true,
                            isFinishedLoading: true,
                            didYouMean: nextProps.did_you_mean
                        });
                    } else {
                        this.setState({
                            noResults: false,
                            isInfiniteLoading: false,
                            isFinishedLoading: true,
                            didYouMean: nextProps.did_you_mean
                        });
                    }
                }
                let iconId;
                iconId = this.getIconFromUrl();
                if (iconId) {
                    if (!this.props.activeIcon && !this.state.isHeroFetching) {
                        this.loadIconForHero(iconId);
                    }
                }
                break;
            case actionTypes.SEARCH_ICONS_FAILURE:
            case actionTypes.FETCH_BEST_COLLECTIONS_FAILURE:
                this.setState({
                    noResults: true,
                    isInfiniteLoading: false,
                    isFinishedLoading: true
                });
                break;
            case actionTypes.FETCH_HERO_ICON_SUCCESS:
                return this.selectIcon(
                    nextProps.activeIcon,
                    null,
                    "row.0",
                    false
                );
                break;
        }

        if (nextProps.queryInfo !== undefined) {
            if (!this.state.savedQueryInfo) {
                this.setState({
                    savedQueryInfo: true
                });
                nextProps.saveQueryInfo({
                    counts: nextProps.queryInfo.counts,
                    query: nextProps.queryInfo.query,
                    result_type: nextProps.queryInfo.result_type,
                    scope: nextProps.queryInfo.scope,
                    creator: nextProps.queryInfo.creator,
                    scope: nextProps.queryInfo.scope,
                    did_you_mean: nextProps.queryInfo.did_you_mean,
                    scope_id: nextProps.queryInfo.scope_id,
                    collection: nextProps.queryInfo.collection
                });
            }
        }
    }

    constructor(props) {
        super(props);

        // remove the need for so much data to be in state
        this.state = {
            pageContext: props.args.pageContext,
            query: get_parameter_by_name("q"),
            collection: {
                id: get_parameter_by_name("collection")
            },
            creator: {
                id: get_parameter_by_name("creator")
            },
            similar: get_parameter_by_name("similar"),
            showHero: false,
            did_you_mean: null,
            iconsPerRow: 6,
            isInfiniteLoading: false,
            isFinishedLoading: true,
            heroRowKey: "row.0",
            heroIconScale: 100,
            historyKeepState: false,
            noResults: false,
            collectionQuery: null,
            collectionIndex: null,
            downloadStatus: DownloadStore.getCurrentStatus()
        };
    }

    buildUrl(icon_id) {
        // should be simpler
        let iconPathMatch, path, qs, termIconPathMatch, termPathMatch, url;
        path = window.location.pathname;
        qs = window.location.search;
        termPathMatch = /\/term\/[^\/]+\//;
        termIconPathMatch = /\/term\/[^\/]+\/\d+\//;
        iconPathMatch = /\/\d+\/$/;
        if (path.match(termIconPathMatch) && icon_id) {
            url = path.replace(iconPathMatch, "/" + icon_id + "/") + qs;
        } else if (path.match(termIconPathMatch)) {
            url = path.replace(iconPathMatch, "/") + qs;
        } else if (path.match(termPathMatch) && icon_id) {
            url = path + icon_id + "/" + qs;
        } else {
            url = updateQuerystring("i", icon_id, path + qs);
        }
        return url;
    }
    setUrlState(stateObj, title, url) {
        if (!history.pushState) {
            return;
        }
        // if current url === the url state state to be pushed, dont use push state
        if (location.pathname + location.search !== url) {
            if (this.state.historyKeepState === true) {
                this.setState({
                    historyKeepState: false
                });
                history.pushState(stateObj, title, url);
            } else {
                history.replaceState(stateObj, title, url);
            }
        }
    }
    updateUrl(icon_id) {
        return this.setUrlState(null, null, this.buildUrl(icon_id));
    }
    getIconFromUrl() {
        let icon_id;
        let path;
        icon_id = get_parameter_by_name("i");
        if (!isNaN(parseInt(icon_id))) {
            return icon_id;
        }
        path = window.location.pathname;
        if (path.match(/\/term\/[^\/]+\/\d+\//)) {
            return path.split("/")[3];
        }
        return null;
    }
    getSearchData(icon) {
        let searchData;
        searchData = {
            resultIndex: this.getIndexOfIconById(icon.id),
            query: this.state.query,
            moreLikeThisId: this.state.similar,
            collectionIndex: this.state.collectionIndex
        };
        if (this.state.collectionQuery) {
            searchData.query = this.state.collectionQuery;
        }
        return searchData;
    }
    selectIcon(icon, iconKey, rowKey, animateScroll) {
        // too many params and one is mutated

        if (animateScroll === null) {
            animateScroll = true;
        }
        if (icon !== null) {
            this.updateUrl(icon.id);
            icon.searchData = this.getSearchData(icon);
        } else {
            this.updateUrl();
        }

        return this.setState({
            showHero: !!icon,
            selectedIcon: icon,
            iconKey,
            heroRowKey: rowKey,
            animateScroll,
            isHeroFetching: false
        });
    }
    loadIconForHero(id) {
        let rowIndex = 0;
        // if(this.props.icons && this.props.icons.length) {
        // let index = this.props.icons.findIndex(i => i.id == id);
        // if (index >= 0) {
        //     rowIndex = Math.floor(index / 6);
        //     if (this.shouldSeeAds()) {
        //         let numAdRows = Math.floor(rowIndex / 6);
        //         if (rowIndex > 9) {
        //             numAdRows -= 1;
        //         }
        //         rowIndex += numAdRows;
        //     }
        // }

        this.selectIcon({ id }, null, `row.${rowIndex}`, false);
        // } else {
        //     console.log('waiting for icons')
        // }
    }
    showOriginalIconInHero() {
        return this.selectIcon(icon, null, "row.0", false);
    }
    handleIconShift(direction) {
        let iconIndex, newIconIndex;
        if (this.state.selectedIcon) {
            this.props.icons.forEach(icon => {
                if (icon.id === this.state.selectedIcon.id) {
                    iconIndex = this.props.icons.indexOf(icon);
                }
            });
            switch (direction) {
                case "next":
                    newIconIndex = iconIndex + 1;
                    break;
                case "prev":
                    newIconIndex = iconIndex - 1;
                    break;
                case "up":
                    newIconIndex = iconIndex - this.state.iconsPerRow;
                    break;
                case "down":
                    newIconIndex = iconIndex + this.state.iconsPerRow;
                    break;
            }
            if (newIconIndex > -1 && newIconIndex < this.props.icons.length) {
                return this.selectIconByIndex(newIconIndex, false);
            }
        }
    }
    getIndexOfIconById(id) {
        let index;
        this.props.icons.forEach(icon => {
            if (icon.id === id) {
                index = this.props.icons.indexOf(icon);
            }
        });
        return index;
    }
    selectIconByIndex(index, animateScroll) {
        let icon, iconKey, rowKey;
        icon = this.props.icons[index];
        iconKey = icon.id;
        rowKey = "row." + Math.floor(index / this.state.iconsPerRow);
        return this.selectIcon(icon, iconKey, rowKey, animateScroll);
    }
    handleHeroClose(e) {
        if (e) {
            e.preventDefault();
        }

        setTimeout(() => {
            this.setState({
                showHero: false
            });
        }, 250);

        $(
            ".hero-container > .container, .nounproject-icon-hero > .container"
        ).animate(
            {
                opacity: 0
            },
            100
        );
        return $(
            ".hero-container > .container, .nounproject-icon-hero > .container"
        ).slideUp(
            200,
            (_this => () => _this.selectIcon(null, null, null))(this)
        );
    }
    handleHeroIconScale(direction) {
        let iconScale;
        if (direction === "bigger") {
            iconScale = this.state.heroIconScale + 10;
        }
        if (direction === "smaller") {
            iconScale = this.state.heroIconScale - 10;
        }
        if (iconScale > 100) {
            iconScale = 100;
        }
        if (iconScale < 10) {
            iconScale = 10;
        }
        return this.setState({
            heroIconScale: iconScale
        });
    }

    shouldSeeAds() {
        if (this.props.currentUser === undefined) {
            return true;
        }
        if (this.props.currentUser.is_anonymous) {
            return true;
        }
        if (!this.props.currentUser.permissions.market === "premium") {
            return true;
        }
        return false;
    }

    buildElements(icons) {
        let adRowKey, currentRow, elements, rowKey, showHero;
        currentRow = 0;
        elements = [];
        while (icons.length > 0) {
            rowKey = "row." + currentRow;
            adRowKey = "row-" + currentRow + "-ad";
            showHero = false;
            currentRow++;
            if (rowKey === this.state.heroRowKey && this.state.showHero) {
                showHero = true;
            }
            if (this.shouldSeeAds() && (currentRow + 3) % 6 === 0) {
                if (currentRow !== 9) {
                    elements.push(
                        <section
                            key={adRowKey}
                            className="row-container advertisement"
                        >
                            <div
                                className="Grid-cell-row container _6"
                                style={{ background: "#ffffff" }}
                            >
                                <iframe
                                    src={`https://ad.doubleclick.net/ddm/adi/N718679.3040413THENOUNPROJECT.CO/B20258164.204341598;sz=728x90;ord=[${Math.floor(
                                        Date.now() / 1000
                                    )}];dc_lat=;dc_rdid=;tag_for_child_directed_treatment=?`}
                                    scrolling="no"
                                    marginHeight="0"
                                    marginWidth="0"
                                    height="90"
                                    width="728"
                                    allowTransparency="1"
                                    style={{
                                        margin: "30px auto 0",
                                        border: "none"
                                    }}
                                >
                                    <script
                                        src={`https://ad.doubleclick.net/ddm/adj/N718679.3040413THENOUNPROJECT.CO/B20258164.204341598;abr=!ie;sz=728x90;ord=[${Math.floor(
                                            Date.now() / 1000
                                        )}];dc_lat=;dc_rdid=;tag_for_child_directed_treatment=?`}
                                    />
                                </iframe>
                            </div>
                        </section>
                    );
                } else {
                    elements.push(<CollectionCarousel key={adRowKey} />);
                }
            } else if (currentRow === 9) {
                elements.push(<CollectionCarousel key={adRowKey} />);
            }

            elements.push(
                <IconRow
                    collection={this.state.collection}
                    icons={icons.splice(0, this.state.iconsPerRow)}
                    iconsPerRow={this.state.iconsPerRow}
                    showHero={showHero}
                    rowKey={rowKey}
                    key={rowKey}
                    selectedIcon={
                        this.state.selectedIcon && this.state.selectedIcon.id
                    }
                    heroIcon={this.state.selectedIcon}
                    heroIconScale={this.state.heroIconScale}
                    onSelectIcon={this.selectIcon.bind(this)}
                    onHeroClose={this.handleHeroClose.bind(this)}
                    animateScroll={this.state.animateScroll}
                    onHoverIcon={this.props.onHoverIcon}
                />
            );
        }
        return elements;
    }

    handleInfiniteLoad() {
        if (!this.state.isInfiniteLoading) {
            this.setState({
                isInfiniteLoading: true,
                isFinishedLoading: false
            });

            switch (this.props.args.pageContext) {
                case "search":
                    let query = "";
                    if (this.state.query) {
                        query = encodeURIComponent(this.state.query.trim());
                    }

                    if (this.state.creator.id) {
                        // search creator's icons
                        this.props.searchCreatorIcons(
                            query,
                            this.state.creator.id,
                            this.props.page + 1
                        );
                    } else if (this.state.collection.id) {
                        // search collections's icons
                        this.props.searchCollectionIcons(
                            query,
                            this.state.collection.id,
                            this.props.page + 1
                        );
                    } else {
                        // normal search
                        this.props.searchIcons(query, this.props.page + 1);
                    }
                    break;
                case "termDetail":
                    let term = window.location.pathname.split("/")[2];
                    this.props.searchTerm(term, this.props.page + 1);
                    break;
                case "recent":
                    this.props.fetchRecentIcons(72, this.props.page + 1);
                    break;
                case "browse":
                    this.props.fetchBestCollectionIcons(
                        72,
                        this.props.page + 1
                    );
                    break;
                case "userUploads":
                    this.props.searchCreatorUploads(
                        window.location.pathname.split("/")[1],
                        this.props.page + 1
                    );
                    break;
                case "collectionDetail":
                    this.props.fetchCollection(
                        this.props.args.collection.id,
                        this.props.page + 1
                    );
                    break;
            }
        }
    }
    render() {
        let infoBar, iconList, loading, noResults;

        if (this.props.icons.length > 0) {
            iconList = this.props.icons.slice(0);
            iconList = this.buildElements(iconList);
        }

        if (!this.state.isFinishedLoading) {
            loading = (
                <IconlistLoading
                    isFinishedLoading={this.state.isFinishedLoading}
                    iconsPerRow={this.state.iconsPerRow}
                />
            );
        }
        if (this.state.noResults) {
            noResults = (
                <NoIconResults
                    query={this.state.query}
                    creator={this.props.creator}
                    collection={this.props.collection}
                    suggestion={this.state.didYouMean}
                    scope={this.props.scope}
                />
            );
            loading = null;
        }
        if (this.props.args.pageContext === "search") {
            infoBar = (
                <SearchInfoBarContainer
                    searchType="icons"
                    query={this.state.query}
                    didYouMean={this.state.didYouMean}
                />
            );
        }

        let listClass = classnames("icon-list", {
            "icon-list-showing-hero": this.state.showHero
        });

        return (
            <div className={listClass}>
                {infoBar}
                {noResults}
                {iconList}
                <Waypoint
                    onEnter={this.handleInfiniteLoad.bind(this)}
                    threshold={1.0}
                />
                {loading}
                <Modal />
            </div>
        );
    }
    onDownloadChange() {
        return this.setState({
            downloadStatus: DownloadStore.getCurrentStatus()
        });
    }
    componentDidMount() {
        this.handleInfiniteLoad();
        let collectionQuery;

        collectionQuery = get_parameter_by_name("oq");
        if (collectionQuery) {
            this.state.collectionQuery = collectionQuery;
            this.state.collectionIndex = get_parameter_by_name("cidx");
        }

        DownloadStore.addListener("change", this.onDownloadChange.bind(this));

        // bind key actions
        return $(document).bind(
            "keydown",
            (_this => event => {
                let down = 40,
                    esc = 27,
                    left = 37,
                    minus = [189, 173],
                    plus = [187, 61],
                    ref = event.keyCode,
                    ref1,
                    ref2,
                    right = 39,
                    up = 38;

                if ($("input:focus").length > 0) {
                    // Check to see if any input is focused.
                    return;
                }
                if ($(".download-modal").length === 1) {
                    return;
                }
                if (this.props.blockNavigation && ref != esc) {
                    return;
                }
                if ($(document.activeElement).hasClass("custom-color")) {
                    return;
                }
                if ($(document.activeElement).prop("id") === "search-input") {
                    return;
                }
                if (DownloadStore.getCurrentPhase() === "AUTHENTICATE") {
                    return;
                }
                if (
                    ref === left ||
                    ref === right ||
                    ref === up ||
                    ref === down
                ) {
                    event.preventDefault();
                }
                switch (event.keyCode) {
                    case right:
                        _this.handleIconShift("next");
                        break;
                    case left:
                        _this.handleIconShift("prev");
                        break;
                    case up:
                        _this.handleIconShift("up");
                        break;
                    case down:
                        _this.handleIconShift("down");
                        break;
                    case esc:
                        _this.handleHeroClose();
                }
                if (((ref1 = event.keyCode), plus.indexOf(ref1) >= 0)) {
                    return _this.handleHeroIconScale("bigger");
                }
                if (((ref2 = event.keyCode), minus.indexOf(ref2) >= 0)) {
                    return _this.handleHeroIconScale("smaller");
                }
            })(this)
        );
    }
}

function findPaginationState(state, props) {
    let page;

    switch (props.args.pageContext) {
        case "search":
            if (state.icons.creator) {
                // search creator's icons
                return (page =
                    state.pagination.searchCreatorIcons["userIcons"].pageCount);
            } else if (state.icons.collection) {
                // search collection's icons
                return (page =
                    state.pagination.searchCollectionIcons["collectionIcons"]
                        .pageCount);
            } else {
                if (!state.icons.query) {
                    return (page = 1);
                }
                return (page =
                    state.pagination.searchIcons[
                        encodeURIComponent(state.icons.query.trim())
                    ].pageCount);
            }
            break;
        case "termDetail":
            let term = window.location.pathname.split("/")[2];
            return (page = state.pagination.searchTerm[term].pageCount);
            break;
        case "recent":
            return (page =
                state.pagination.fetchRecentIcons["recent"].pageCount);
            break;
        case "browse":
            return (page =
                state.pagination.fetchBestCollectionIcons["browse"].pageCount);
            break;
        case "browse":
            return (page =
                state.pagination.fetchBestCollectionIcons["browse"].pageCount);
            break;

        case "userUploads":
            return (page =
                state.pagination.searchCreatorUploads["userUploads"].pageCount);
            break;
        case "collectionDetail":
            return (page =
                state.pagination.fetchCollection["collectionIcon"].pageCount);
            break;
    }
}

function mapStateToProps(state, nextProps) {
    let activeIcon,
        creator,
        collection,
        currentUser,
        keys = [],
        page = 0,
        query,
        queryInfo,
        icons = [],
        result_type,
        did_you_mean,
        scope;

    let { download, apiResponse, modal, user } = state;
    let { status, license, waitingForAuth } = download;

    let notInModal =
        status != phases.DOWNLOAD_READY && license != licenses.CREATIVE_COMMONS;
    let downloadFlowInProgress =
        status && status != phases.INITIAL && notInModal;
    let modalOpen = !isEmpty(modal.all);
    let blockNavigation = downloadFlowInProgress || waitingForAuth || modalOpen;

    if (user.is_anonymous !== undefined) {
        currentUser = user;
    }

    if (state.search.queryInfo) {
        query = state.search.queryInfo.query;
        result_type = state.search.queryInfo.result_type;
        creator = new Object();
        collection = new Object();
        creator = state.search.queryInfo.creator;
        collection = state.search.queryInfo.collection;
        scope = state.search.queryInfo.scope;
        did_you_mean = state.search.queryInfo.did_you_mean;
    }

    if (state.icons.keys) {
        page = findPaginationState(state, nextProps);
        keys = state.icons.keys;
        state.icons.keys.forEach(iconId => {
            let icon = state.icons[iconId];
            if (state.icons.active_icon !== undefined) {
                activeIcon = state.icons[state.icons.active_icon.id];
            }
            icons.push(icon);
        });
        queryInfo = {
            counts: state.icons.counts,
            query: state.icons.query,
            result_type: state.icons.result_type,
            creator: state.icons.creator,
            collection: state.icons.collection,
            scope: state.icons.scope,
            did_you_mean: state.icons.did_you_mean,
            scope_id: state.icons.scope_id
        };
    }
    if (state.icons.featured_icons) {
        page = findPaginationState(state, nextProps);
        keys = state.icons.featured_icons.keys;
        if (
            state.icons.active_icon !== undefined &&
            state.icons.featured_icons[state.icons.active_icon.id]
        ) {
            activeIcon = state.icons.featured_icons[state.icons.active_icon.id];
        }
        state.icons.featured_icons.keys.forEach(iconId => {
            let icon = state.icons.featured_icons[iconId];
            icons.push(icon);
        });
    }
    return {
        activeIcon,
        apiResponse,
        creator,
        collection,
        currentUser,
        icons,
        page,
        query,
        queryInfo,
        result_type,
        did_you_mean,
        scope,
        blockNavigation
    };
}

// export default Icon_List;
module.exports = connect(mapStateToProps, {
    fetchBestCollectionIcons: actions.fetchBestCollectionIcons,
    fetchCollection: actions.fetchCollection,
    fetchHeroIcon: actions.fetchHeroIcon,
    fetchRecentIcons: actions.fetchRecentIcons,
    searchCreatorIcons: actions.searchCreatorIcons,
    searchCreatorUploads: actions.searchCreatorUploads,
    searchCollectionIcons: actions.searchCollectionIcons,
    searchIcons: actions.searchIcons,
    searchTerm: actions.searchTerm,
    saveQueryInfo: actions.saveQueryInfo
})(Icon_List);
